

import { IUPDATE_FAQ_DATA_ACTIONDATA, IUPDATE_FAQ_DATA, IUPDATE_META_DATA_ACTIONDATA, IUPDATE_META_DATA, } from './validation';
import { UPDATE_FAQ_DATA, UPDATE_META_DATA, UPDATE_GOSAFE_BANNER, UPDATE_OFFERS_DATA, UPDATE_RTC_HOME_BANNER, UPDATE_BUS_HOME_CAROUSEL, SAVE_LOYALTY_DATA } from './constants';


export function updateFAQDATA(actionData: IUPDATE_FAQ_DATA_ACTIONDATA): IUPDATE_FAQ_DATA {
  return {
    type: UPDATE_FAQ_DATA,
    actionData
  }

}
export function updateMETADATA(actionData: IUPDATE_META_DATA_ACTIONDATA): IUPDATE_META_DATA {
  return {
    type: UPDATE_META_DATA,
    actionData
  }
}

export function updateGoSafeBanners(actionData: any): any {
  return {
    type: UPDATE_GOSAFE_BANNER,
    actionData
  }

}

export function updateHomePageOffers(actionData: any): any {
  return {
    type: UPDATE_OFFERS_DATA,
    actionData
  }
}

export const updateRTCHomeBanner = (actionData: any): any => {
  return {
    type: UPDATE_RTC_HOME_BANNER,
    actionData
  }
}

export const updateBusHomeCarousel = (actionData: any): any => {
  return {
    type: UPDATE_BUS_HOME_CAROUSEL,
    actionData
  }
}

export const saveLoyaltyData = (actionData: any): any => {
  return {
    type: SAVE_LOYALTY_DATA,
    actionData
  }
}